<template>
  <ul class="slider-thumbnails">
    <template v-for="(item, index) in DATA">
      <li class="slider-thumbnails__item" @click="activeSlider(index)">
        <ListItemGif :data="item" v-if="item.type === 'gif'" />
        <ListItemVideo :data="item" v-else-if="item.type === 'video'" />
        <ListItemThumbnail :src="item.url" :label="item.caption" v-else />
      </li>
    </template>
  </ul>
</template>

<script setup>
  import { Props } from './props';
  import { testData } from '@/Groups/Slider/private/testing/testData';
  import { useStore } from 'vuex';
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';
  //---------------------------
  import ListItemThumbnail from '@/Groups/Slider/private/ui/ListItemThumbnail/ListItemThumbnail.vue';
  import ListItemGif from '@/Groups/Slider/private/ui/ListItemGif/ListItemGif.vue';
  import ListItemVideo from '@/Groups/Slider/private/ui/ListItemVideo/ListItemVideo.vue';
  //---------------------------
  const props = defineProps(Props());
  const store = useStore();
  //---------------------------
  const DATA = props.data;
  //---------------------------
  //Активировать слайдер
  const activeSlider = async (index) => {
    store.dispatch('Slider/activeSlider', { data: DATA, index: index });
    store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.slider);
  }
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>